import type { ReactNode } from 'react';
import { Lock } from 'lucide-react';
import type { Role } from '../../types';
import { useApp } from '../../context/AppContext';
import { useT } from '../../i18n';
import { MessagePage } from '../common/MessagePage';

export function RequireRoles({ roles, children }: { roles: Role[]; children: ReactNode }) {
  const { role } = useApp();
  const t = useT();
  if (!roles.includes(role)) return <MessagePage icon={Lock} title={t('soon.denied')} body={t('soon.deniedBody', { role: t(`roles.${role}`) })} />;
  return <>{children}</>;
}
